import { useFetchMixAPi1, useMixApi1Toast } from "hooks";
import { getURLWithParams } from "utils/context";

export const useCodigosSpedList = classId =>
  useFetchMixAPi1(
    classId
      ? getURLWithParams("/legislacao/codigo-sped", {
          class_piscofins_id: classId,
        })
      : null,
  );

export const useCategoriasPisCofins = classId =>
  useFetchMixAPi1(
    classId ? `/legislacao/piscofins/${classId}/categorias` : null,
  );

export const useCodigoSped = () => {
  const { onSend, isLoading } = useMixApi1Toast();

  const onSave = (data, id = null) =>
    onSend({
      endpoint: id
        ? `/legislacao/codigo-sped/${id}`
        : "/legislacao/codigo-sped",
      type: id ? "PUT" : "POST",
      data,
      messageSuccess: id
        ? "Código SPED editado com sucesso"
        : "Código SPED cadastrado com sucesso",
      messageFail: id
        ? "Não foi possível editar o Código SPED"
        : "Não foi possível cadastrar o Código SPED",
    });

  const onRemove = id =>
    onSend({
      endpoint: `/legislacao/codigo-sped/${id}`,
      type: "DELETE",
      messageSuccess: "Código SPED excluído com sucesso",
      messageFail: "Não foi possível excluir o Código SPED",
    });
  return { onSave, onRemove, isLoading };
};
